import { useState } from "react";
import { useNavigate } from "react-router";
import { useMutation } from "urql";
import {
  CreatePersonaDocument,
  PageHeader,
} from "visumo-data-agent-web-shared";

import { HelpIcon } from "../help/HelpIcon";

import { PersonaForm, type PersonaUserError } from "./PersonaForm";

export function PersonaNewPage() {
  const navigate = useNavigate();
  const [state, createPersona] = useMutation(CreatePersonaDocument);
  const [userErrors, setUserErrors] = useState<PersonaUserError[]>([]);

  return (
    <div className="vd-page">
      <PageHeader
        title="ペルソナを登録する"
        description="登録すると、この人の観点で商品を採点できるようになります。"
        titleExtra={<HelpIcon slug="personas/edit" />}
      />
      <PersonaForm
        mode="create"
        initial={{
          name: "",
          description: "",
          attributes: [],
          barriers: [],
          questions: [],
        }}
        userErrors={userErrors}
        submitting={state.fetching}
        onCancel={() => navigate("/personas")}
        onSubmit={(values) => {
          void createPersona({
            input: {
              name: values.name,
              description: values.description,
              attributes: values.attributes,
              barriers: values.barriers,
              questions: values.questions,
            },
          }).then((result) => {
            if (result.error !== undefined) {
              setUserErrors([
                {
                  field: null,
                  code: "INTERNAL_ERROR",
                  message: `保存できませんでした: ${result.error.message}`,
                },
              ]);
              return;
            }
            const payload = result.data?.createPersona;
            if (payload === undefined) {
              return;
            }
            if (payload.userErrors.length > 0) {
              setUserErrors([...payload.userErrors]);
              return;
            }
            setUserErrors([]);
            navigate("/personas");
          });
        }}
      />
    </div>
  );
}
